const doc = [({"empty":"Vuoto", "payment_period":"Periodo di pagamento"})];
module.exports = doc.length <= 1 ? doc[0] : doc;